<template>
    <div>
        <div>
            <!---------------Фильтр--------------->
            <div class="filter-container">
                <div class="left-content">
                    <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                        <template #button-content>
                            <span class="lc"><i class="icon icon-filter"></i> {{ setText('filter') }} </span><span class="rc"><i
                            class="icon icon-keyboard"></i></span>
                        </template>
                        <div>
                            <div class="top-content">
                                <span>{{ setText('filter_params') }}</span>
                                <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                            </div>
                            <div class="filter-block">
                                <b-form-group :label="setText('project')">
                                    <div>
                                        <b-form-checkbox v-model="project"  @input="loadData()" switch/>
                                    </div>
                                </b-form-group>
                            </div>
                            <!--------------- Фмнансовый год ------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('fin_year')">
                                    <multiselect v-show="year"
                                                 ref="bcPlanYear"
                                                 v-model="planPeriod"
                                                 track-by="name"
                                                 label="name"
                                                 :placeholder="setText('year_select')"
                                                 :options="year"
                                                 :searchable="false"
                                                 :allow-empty="false"
                                                 :show-labels="false">
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------data------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('date')">
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="date"
                                        format = "YYYY-DD-MM"
                                        type="date"
                                        style="max-width: 1200px"
                                        ref="filterDate"
                                        :append-to-body="false"
                                    />
                                </b-form-group>
                            </div>
                            <!---------------------АБП------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('abp')">
                                    <multiselect
                                        v-model="currAbp"
                                        label="localText"
                                        :placeholder="setText('abp_select')"
                                        :options="abpBase"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="loadFilters"
                                        ref="filterAbp"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!----------------Подведомственные-------------------->
                            <div class="filter-block" v-if="currAbp && [261].includes(currAbp.abp) && (abp !== 0)">
                                <b-form-group :label="setText('subordinate')">
                                    <multiselect
                                        v-model="abp261gu"
                                        :options="departGU"
                                        label="localText"
                                        @input="sortData"
                                        ref="refDepartGU"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------ГУ-------------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('ga')"> <!--v-if="['ipf', 'uf'].includes(accessLevels.position) || (['abp'].includes(accessLevels.position) && checkedGU)"-->
                                    <multiselect
                                        :disabled="!guBase.length"
                                        v-model="currGu"
                                        label="localText"
                                        :placeholder="setText('ga_select')"
                                        :options="guBase"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        @input="guChange"
                                        ref="filterGu"
                                    >
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!-----------------Программа ---------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('program')">
                                    <multiselect
                                        v-model="curPrg"
                                        label="localText"
                                        track-by="prg"
                                        :placeholder="setText('program_select')"
                                        :options="prgBase"
                                        :multiple="true"
                                        :searchable="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        @input="chgPrg"
                                        ref="curProgRef"
                                    >
                                        <template slot="beforeList"><b-badge pill variant="primary" @click="selectAllPrgChanged()">{{setText('all')}}</b-badge></template>
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <template v-if="!isOpen"><template v-if="values.length > 1">
                                                <span class="multiselect__single_prg"
                                                      id="multiselect__single_prg">
                                                    -- {{ displayPrgText(values.length) }} --
                                                </span>
<!--                                                    <b-tooltip target="multiselect__single_prg" placement="left" variant="info">-->
<!--                                                        <p style="margin-bottom: 0" v-for="prg in values"-->
<!--                                                           :key="prg.prg">-->
<!--                                                            {{ prg.localText }}</p>-->
<!--                                                    </b-tooltip>-->
                                                </template>
                                                <template v-else-if="values.length === 1">
                                                    <span>
                                                        {{ values[0].localText }}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!-----------------Подпрограмма -------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('ppr')">
                                    <multiselect
                                        v-model="curPpr"
                                        label="localText"
                                        track-by="ppr"
                                        :placeholder="setText('ppr_select')"
                                        :options="pprBase"
                                        :multiple="true"
                                        :searchable="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        @input="chgPpr"
                                        ref="subProgRef">
                                        <template slot="beforeList"><b-badge pill variant="primary" @click="selectAllPprChanged()">
                                            {{ setText('all') }}</b-badge></template>
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <template v-if="!isOpen">
                                                <template v-if="values.length > 1">
                                                <span class="multiselect__single"
                                                      id="multiselect__single_ppr">
                                                    -- {{ displayPprText(values.length) }} --
                                                </span>
<!--                                                    <b-tooltip target="multiselect__single_ppr" placement="left" variant="info">-->
<!--                                                        <p style="margin-bottom: 0" v-for="ppr in values"-->
<!--                                                           :key="ppr.ppr">-->
<!--                                                            {{ ppr.localText }}</p>-->
<!--                                                    </b-tooltip>-->
                                                </template>
                                                <template v-else-if="values.length === 1">
                                                    <span>
                                                        {{ values[0].localText }}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!-----------------Специфика------------------------>
                            <div class="filter-block">
                                <b-form-group :label="setText('spf')">
                                    <multiselect
                                        v-model="curSpf"
                                        label="localText"
                                        track-by="spf"
                                        :placeholder="setText('spf_select')"
                                        :options="spfBase"
                                        :multiple="true"
                                        :searchable="true"
                                        :close-on-select="false"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        ref="spfRef">
                                        <template slot="beforeList"><b-badge pill variant="primary" @click="selectAllSpfChanged()">{{setText('all')}}</b-badge></template>
                                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                                            <template v-if="!isOpen">
                                                <template v-if="values.length > 1">
                                                <span class="multiselect__single"
                                                      id="multiselect__single_spf">
                                                    -- {{ displaySpfText(values.length) }} --
                                                </span>
<!--                                                    <b-tooltip target="multiselect__single_spf" placement="left" variant="info">-->
<!--                                                        <p style="margin-bottom: 0" v-for="spf in values"-->
<!--                                                           :key="spf.spf">-->
<!--                                                            {{ spf.spf }} , </p>-->
<!--                                                    </b-tooltip>-->
                                                </template>
                                                <template v-else-if="values.length === 1">
                                                    <span>
                                                        {{ values[0].localText }}
                                                    </span>
                                                </template>
                                            </template>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </div>
                            <!---------------------Регион---------------------->
                            <div class="filter-block">
                                <b-form-group :label="setText('obl')">
                                    <multiselect
                                        v-model="currRegion"
                                        label="localText"
                                        :placeholder="setText('region_select')"
                                        :options="regionBase"
                                        :searchable="true"
                                        :allow-empty="false"
                                        :show-labels="false"
                                        ref="filterReg"
                                    />
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group class="special-radio-css" :label="setText('data_type')">
                                    <b-form-radio-group
                                        ref="bcVersion"
                                        id="radio-group-1"
                                        v-model="version"
                                        :options="versions"
                                        name="radio-options_1"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group :label="setText('mutually_redeeming')">
                                    <b-form-radio-group
                                        ref="bcVZK"
                                        id="radio-group-2"
                                        v-model="vzk"
                                        :options="vzk_list"
                                        name="radio-options_2"
                                    >
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-form-group :label="setText('remains')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="ost" switch/>
                                    </div>
                                </b-form-group>
                                <b-form-group :label="setText('detail_unload')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="fullRep" switch/>
                                    </div>
                                </b-form-group>
                                <b-form-group v-if="transF" :label="setText('scorr_transf')">
                                    <div class="modal__toggle">
                                        <b-form-checkbox v-model="transf" switch/>
                                    </div>
                                </b-form-group>
                            </div>
                            <div class="filter-block">
                                <b-button variant="primary" @click="loadData()">{{setText('apply')}}</b-button>
                            </div>
                        </div>
                    </b-dropdown>
                </div>
            </div>
        </div>
        <div class="actions-tab in-tab">
            <!---------------Форма для скачивания отчета--------------->
            <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                                    <span class="left">
                                        <i class="icon icon-download"></i> {{setText('download')}}
                                    </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-item @click="download(0)">{{setText('scorr_plan_exp')}}</b-dropdown-item>
                <b-dropdown-item @click="downloadIPF(0)">{{setText('downloads.ipf')}}</b-dropdown-item>
                <b-dropdown-item v-if="fullRep" @click="download(1)">{{setText('downloads.scorFG')}}</b-dropdown-item>
                <b-dropdown-item v-if="fullRep" @click="download(2)">{{setText('downloads.scorABP')}}</b-dropdown-item>
                <b-dropdown-item v-if="fullRep && (currAbp !== null && currAbp.abp !== 0 && currAbp.abp !== 124) && (currRegion !== null && currRegion.code.slice(4, 6) === '01')" @click="downloadPlanAbp">{{setText('downloads.detailed_plan')}}</b-dropdown-item>
<!--                <b-dropdown-item v-if="fullRep" @click="downloads()">Детализированный отчет</b-dropdown-item>-->
            </b-dropdown>
            <b-dropdown variant="link" class="info" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                    <div class="btn-download">
                        <div>
                            <span class="left">
                                <i class="icon icon-info"></i>
                            </span>
                            <i class="icon icon-keyboard"></i>
                        </div>
                    </div>
                </template>
                <b-dropdown-text>
                    <div class="info-button">
                        <a href="https://youtu.be/yMq8MASuUCI" target="_blank"><span>{{setText('video_instructions.scorrPlan')}} <i
                            class="icon icon-video"></i></span></a>
                    </div>
<!--                    <div class="info-text">-->
<!--                        <p>Данный режим предназначен для формирования государственным учреждением заявки по внесению изменений-->
<!--                            в индивидуальные планы финансирования по обязательствам и платежам и направления ее-->
<!--                            для утверждения администратору бюджетных программ согласно приказу №540 МФ РК-->
<!--                            «Об утверждении Правил исполнения бюджета и его кассового обслуживания».</p>-->
<!--                    </div>-->
                </b-dropdown-text>
            </b-dropdown>
        </div>
        <!--  хлебные крошки   -->
        <div class="filter-breadcrumb">
            <span class="item-breadcrumb" v-if="project" @click="openFilterByRef('bcProject')"> {{ setText('project')}} </span>
            <span class="item-breadcrumb" v-if="date" @click="openFilterByRef('filterDate')"> {{ date | formatDate }} </span>
            <span class="item-breadcrumb" v-if="currAbp" @click="openFilterByRef('filterAbp')"> {{currAbp.localText}}-{{ setText('abp')}}</span>
            <span class="item-breadcrumb" v-if="abp261gu && abp261gu.code !== 0" @click="openFilterByRef('refDepartGU')">
                {{ setText('subordinate')}} - {{ abp261gu.code }}
            </span>
            <span class="item-breadcrumb" v-if="(currGu && ['ipf', 'uf'].includes(accessLevels.position))" @click="openFilterByRef('filterGu')"> {{currGu.localText}}-{{ setText('ga')}} </span>
            <span class="item-breadcrumb" v-if="currRegion" @click="openFilterByRef('filterReg')"> {{ currRegion.localText}} </span>
            <span class="item-breadcrumb" @click="openFilterByRef('bcVersion')"> {{ versions[version].text }} </span>
            <span class="item-breadcrumb" @click="openFilterByRef('bcVZK')"> {{vzk_list[vzk].text }} </span>
        </div>
        <div class="top-table-line"></div>
        <prg-tree-table :table-data="budgetForm" :accessLevel="accessLevels" :transf="transf"/>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import VueElementLoading from "vue-element-loading";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import {Ax} from "@/utils"
import moment from 'moment';
import PrgTreeTable from "./PrgTreeTable";
import store from "@/services/store";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import {log} from "@amcharts/amcharts4/.internal/core/utils/Log";
// расходы
export default {
    name: "expensTable",
    components: { DatePicker, 'loading': VueElementLoading, PrgTreeTable },
    mixins: [AlterationI18nMixin],
    props: ["accessLevels", "userId", "isLoadToJournalEnabled"],
    data() {
        return {
            date: new Date(),
            loading: false,
            budgetForm: [],
            versions: [
                { value: 0, text: this.setText('obligation') },
                { value: 1, text: this.setText('payments') }
            ],
            version: 0,
            currAbp: null,
            abpBase: [],
            prgBase: [],
            pprBase: [],
            spfBase: [],
            currGu: null,
            guBase: [],
            regionBase: [],
            currRegion: null,
            ost: false,
            fullRep: true,
            checkedGU: false,
            visible: false,
            vzk_list: [
                {value: 0, text: this.setText('WITHOUT')},
                {value: 1, text: this.setText('ONLY')},
                {value: 2, text: this.setText('WITH')}
            ],
            vzk: 2,
            planPeriod: null,
            year: [],
            curPrg: [],
            curPpr: [],
            curSpf: [],
            prg: [],
            ppr: [],
            spf: [],
            abp261gu: null,
            departGU: [],
            arrObligation: [],
            arrPayment: [],
            project: false,
            arrGU: {},
            abp: 0,
            baseFilters: [],
            spfName: '',
            transf: false,
            transF: false
        }
    },
    watch: {},
    mounted() {
        this.version = 0;
        // this.visible = ['abp'].includes(this.accessLevels.position);
        this.checkedGU = ['ipf', 'uf'].includes(this.accessLevels.position);
        this.years(this, this.year);
    },
    async created() {
        await this.loadAbpList();
        if (this.currRegion) {
            this.loadFiltersData();
            this.loadDepartGU();
            this.loadData();
        }
        this.$watch('accessLevels', function () {
            // this.visible = ['abp'].includes(this.accessLevels.position);
            this.checkedGU = ['ipf', 'uf'].includes(this.accessLevels.position);
        });
        this.$watch('locale', this.localeChange);
        this.transF = await this.loadSettings('transfers');
    },
    computed: {
        isAllPrgSelected() {
            return (this.curPrg.length === this.prgBase.length)
        },
        isAllPprSelected() {
            return (this.curPpr.length === this.pprBase.length)
        },
        isAllSpfSelected() {
            return (this.curSpf.length === this.spfBase.length)
        },
        locale(){
            return this.$i18n.locale;
        }
    },
    methods: {
        localeChange() {
            this.vzk_list[0].text = this.setText('WITHOUT');
            this.vzk_list[1].text = this.setText('ONLY');
            this.vzk_list[2].text = this.setText('WITH');
            this.versions[0].text = this.setText('obligation');
            this.versions[1].text = this.setText('payments');
            this.loadFiltersData();
        },
        chgParams() {
            switch (this.accessLevels.position) {
                case 'ipf':
                    if (!this.currRegion || !this.currAbp || !this.currGu) { return; }
                    break;
                case 'abp':
                    if (!this.currRegion || !this.currAbp) { return; }
                    break;
                case 'uf':
                    if (!this.currRegion) { return; }
                    break;
                default: break;
            }
            this.loadData();
        },
        async loadRegions() {
            try {
                this.regionBase = [];
                const response = await fetch('/api-py/get-user-regions-by-uuid/' + store.state.user.sub);
                if (response.status === 200) {
                    this.regionBase = await response.json();
                    this.nameLocale(this.regionBase);
                    this.currRegion = this.regionBase[0];
                }
            } catch (error) {
                this.makeToast('danger', this.setText('region'), error.toString());
            }
        }, // справочник регионов
        checkGU() {
            if (this.checkedGU) {
                this.currGu = this.guBase[0];
            } else {
                this.currGu = null;
            }
        },
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            this.$emit('openFilterByRef', refName);
            let refItem;
            switch (refName) {
                case 'bcVersion':
                    refItem = this.$refs.bcVersion;
                    break;
                case 'filterDate':
                    refItem = this.$refs.filterDate;
                    break;
                case 'filterAbp':
                    refItem = this.$refs.filterAbp;
                    break;
                case 'filterGu':
                    refItem = this.$refs.filterGu;
                    break;
                case 'filterReg':
                    refItem = this.$refs.filterReg;
                    break;
                case 'bcVZK':
                    refItem = this.$refs.bcVZK;
                    break;
                case 'refDepartGU':
                    refItem = this.$refs.refDepartGU;
                    break;
                default: break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        makeToast(variant, title, tostbody) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
                appendToast: true
            });
        }, // сообщение
        async download(val) {
            const that = this;
            let cAbp = null;
            let cGu = null;
            if ((this.currGu === null) || (this.currGu === undefined)) {
                cGu = null;
            } else {
                if (that.currGu.code === 0) {
                    cGu = null;
                    if (this.arrGU.length > 0) {
                        cGu = this.arrGU;
                    }
                } else {
                    cGu = "'" + that.currGu.code.toString() + "'";
                }
            }
            if ((this.currAbp === null)  || (this.currAbp === undefined)) {
                cAbp = null;
            } else {
                if (this.currAbp.abp === 0) {
                    cAbp = null;
                } else {
                    cAbp = this.currAbp.abp;
                }
            }
            const prgCount = [];
            const pprCount = [];
            const spfCount = [];
            if (this.curPrg.length !== this.prgBase.length) {
                this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
            }
            if (this.curPpr.length !== this.pprBase.length) {
                this.curPpr.forEach((row, ind) => { pprCount.push(row.ppr); });
            }
            if (this.curSpf.length !== this.spfBase.length) {
                this.curSpf.forEach((row, ind) => { spfCount.push(row.spf); });
            }

            let name = ''
            if (val === 0) {
                name = 'Скорректированный план(Расходы)'
            } else if (val === 1) {
                name = 'Скорректированный план(Расходы без ФГ)'
            } else if (val === 2) {
                name = 'Скорректированный план(Расходы без ФГ и АБП)'
            }

            let filename = ''
            if (cAbp) {
                filename += `_${cAbp}`
            }
            if (this.abp261gu === null) {
                if (cGu) {
                    filename += `_${cGu.replace(/'/g, "")}`
                }
            } else {
                if (this.currGu?.code === 0){
                    filename += `_${this.abp261gu.code}`
                } else {
                    if (cGu) {
                        const guStr = Array.isArray(cGu) ? cGu.join(',') : cGu;
                        filename += `_${guStr.replace(/"/g, "")}`;
                    }

                }
            }
            filename += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`
            switch (this.$i18n.locale) {
                case 'kk':
                    if (val === 0) {
                        filename = `Түзетілген жоспар(Шығыс)${filename}.xlsx`
                    } else {
                        if (val === 1) {
                            filename = `Түзетілген жоспар(Шығыс ФГсыз)${filename}.xlsx`
                        } else {
                            if (val === 2) {
                                filename = `Түзетілген жоспар(Шығыс ФГ жөне АБПсыз)${filename}.xlsx`
                            }
                        }
                    }
                    break;
                default:
                    if (val === 0) {
                        filename = `Скорректированный план(Расходы)${filename}.xlsx`
                    } else {
                        if (val === 1) {
                            filename = `Скорректированный план(Расходы без ФГ)${filename}.xlsx`
                        } else {
                            if (val === 2) {
                                filename = `Скорректированный план(Расходы без ФГ и АБП)${filename}.xlsx`
                            }
                        }
                    }
            }

            const params = {
                abp: cAbp,
                gu: cGu,
                abp261gu: that.abp261gu ? this.abp261gu.code : null,
                type: that.version,
                level: that.accessLevels.position,
                region: that.currRegion.code,
                regionText: that.currRegion.text,
                year: that.planPeriod.year,
                date: moment(that.date).format('YYYY-MM-DD'),
                dateRt: moment(that.date).format('DD.MM.YYYY'),
                ost: that.ost,
                vzk: that.vzk,
                project: that.project,
                fullRep: that.fullRep,
                locale: that.$i18n.locale,
                details: val,
                uid: that.userId,
                prgCount: prgCount,
                pprCount: pprCount,
                spfCount: spfCount,
                transf: that.transf,
                report_key: 'SCOR_PLAN_EXPENSE',
                agreement_status: that.project ? '1' : '39',
                source_tab: 'scorr_plan',
                name: name,
                user_id: this.$store.getters.user_uuid,
                filename: filename
            }
            if (params.abp261gu) { // Параметр для фильтра журнала
                params['gu261_code'] = params['abp261gu']
            }
            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const response = await fetch('/api-py/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(params),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка при попытке выгрузки')
                    return
                }
                const journalId = await response.text()
                fetch(`/api-py/alteration/journal/${journalId}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                this.$emit('reload-journal')
            } else {
                // Прямая выгрузка
                Ax(
                    {
                        url: '/api-py/scorr-plan-expens-download/' +  encodeURI(JSON.stringify(params)), //  Тело файла
                        method: 'POST',
                        data: that.ajxParams,
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        let name = ''
                        if (cAbp) {
                        name += `_${cAbp}`
                        }
                        if (this.abp261gu === null) {
                            if (cGu) {
                                name += `_${cGu.replace(/'/g, "")}`
                            }
                        } else {
                            if (this.currGu.code === 0){
                                name += `_${this.abp261gu.code}`
                            } else {
                                name += `_${cGu.replace(/'/g, "")}`
                            }
                        }
                        name += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`

                        switch (this.$i18n.locale) {
                            case 'kk':
                                if (val === 0) {
                                    link.setAttribute('download', `Түзетілген жоспар(Шығыс)${name}.xlsx`);// or any other extension
                                } else {
                                    if (val === 1) {
                                        link.setAttribute('download', `Түзетілген жоспар(Шығыс ФГсыз)${name}.xlsx`);// or any other extension
                                    } else {
                                        if (val === 2) {
                                            link.setAttribute('download', `Түзетілген жоспар(Шығыс ФГ жөне АБПсыз)${name}.xlsx`);// or any other extension
                                        }
                                    }
                                }
                                break;
                            default:
                                if (val === 0) {
                                    link.setAttribute('download', `Скорректированный план(Расходы)${name}.xlsx`);// or any other extension
                                } else {
                                    if (val === 1) {
                                        link.setAttribute('download', `Скорректированный план(Расходы без ФГ)${name}.xlsx`);// or any other extension
                                    } else {
                                        if (val === 2) {
                                            link.setAttribute('download', `Скорректированный план(Расходы без ФГ и АБП)${name}.xlsx`);// or any other extension
                                        }
                                    }
                                }
                        }
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        that.error = error;
                    }
                );
            }
        },
        async downloadIPF(val) {
            const that = this;
            let cAbp = null;
            let cGu = null;
            if ((this.currGu === null) || (this.currGu === undefined)) {
                cGu = null;
            } else {
                if (that.currGu.code === 0) {
                    cGu = null;
                    if (this.arrGU.length > 0) {
                        cGu = this.arrGU;
                    }
                } else {
                    cGu = "'" + that.currGu.code.toString() + "'";
                }
            }
            if ((this.currAbp === null)  || (this.currAbp === undefined)) {
                cAbp = null;
            } else {
                if (this.currAbp.abp === 0) {
                    cAbp = null;
                } else {
                    cAbp = this.currAbp.abp;
                }
            }
            const prgCount = [];
            const pprCount = [];
            const spfCount = [];
            if (this.curPrg.length !== this.prgBase.length) {
                this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
            }
            if (this.curPpr.length !== this.pprBase.length) {
                this.curPpr.forEach((row, ind) => { pprCount.push(row.ppr); });
            }
            if (this.curSpf.length !== this.spfBase.length) {
                this.curSpf.forEach((row, ind) => { spfCount.push(row.spf); });
            }
            let guText = that.currGu.name_ru;
            if (this.$i18n.locale === 'kk') {guText = that.currGu.name_kk;}

            const name = 'ИПФ (скорректированный)'

            let filename = ''
            if (cAbp) {
                filename += `_${cAbp}`
            }
            if (cGu) {
                filename += `_${cGu.replace(/'/g, "")}`
            }
            filename += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`
            switch (this.$i18n.locale) {
                case 'kk':
                    if (val === 0) {
                        filename = `ИПФ (скорректированный)_${name}.xls`
                    }
                    break;
                default:
                    if (val === 0) {
                        filename = `ИПФ (скорректированный)_${name}.xls`
                    }
            }
            const params = {
                abp: cAbp,
                gu: cGu,
                guText: guText,
                type: that.version,
                level: that.accessLevels.position,
                region: that.currRegion.code,
                regionText: that.currRegion.text,
                year: this.planPeriod.year,
                date: moment(that.date).format('YYYY-MM-DD'),
                dateRt: moment(that.date).format('DD.MM.YYYY'),
                ost: that.ost,
                vzk: that.vzk,
                project: that.project,
                fullRep: this.fullRep,
                locale: this.$i18n.locale,
                details: val,
                uid: this.userId,
                prgCount: prgCount,
                pprCount: pprCount,
                spfCount: spfCount,
                transf: that.transf,
                report_key: 'IPF',
                agreement_status: that.project ? '1' : '39',
                source_tab: 'scorr_plan',
                name: name,
                user_id: this.$store.getters.user_uuid,
                filename: filename
            }
            if (this.abp261gu?.code) {
                params['gu261_code'] = this.abp261gu?.code
            }

            if (this.isLoadToJournalEnabled) {
                // Выгрузка в журнал
                const response = await fetch('/api-py/alteration/journal', {
                    method: 'POST',
                    body: JSON.stringify(params),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                })
                if (!response.ok) {
                    this.makeToast('danger', 'Ошибка', 'Ошибка при попытке выгрузки')
                    return
                }
                const journalId = await response.text()
                fetch(`/api-py/alteration/journal/${journalId}`, {
                    method: 'PUT'
                })
                this.makeToast('success', 'Внимание!', 'Началась выгрузка. Для скачивания отчета перейдите во вкладку "Журнал"')
                this.$emit('reload-journal')
            } else {
                // Прямая выгрузка
                Ax(
                    {
                        url: '/api-py/scorr-plan-expens-download-IPF/' + encodeURI(JSON.stringify(params)), //  Тело файла
                        method: 'POST',
                        data: that.ajxParams,
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        let name = ''
                        if (cAbp) {
                            name += `_${cAbp}`
                        }
                        if (cGu) {
                            name += `_${cGu.replace(/'/g, "")}`
                        }
                        name += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`

                        switch (this.$i18n.locale) {
                            case 'kk':
                                if (val === 0) {
                                    link.setAttribute('download', `ИПФ (скорректированный)_${name}.xls`);// or any other extension
                                }
                                break;
                            default:
                                if (val === 0) {
                                    link.setAttribute('download', `ИПФ (скорректированный)_${name}.xls`);// or any other extension
                                }
                        }
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        that.error = error;
                    }
                );
            }
        },
        downloads() {
            const that = this;
            let cAbp = null;
            let cGu = null;
            if ((this.currGu === null) || (this.currGu === undefined)) {
                cGu = null;
            } else {
                if (that.currGu.code === 0) {
                    cGu = null;
                    if (this.arrGU.length > 0) {
                        cGu = this.arrGU;
                    }
                } else {
                    cGu = "'" + that.currGu.code.toString() + "'";
                }
            }
            if ((this.currAbp === null)  || (this.currAbp === undefined)) {
                cAbp = null;
            } else {
                if (this.currAbp.abp === 0) {
                    cAbp = null;
                } else {
                    cAbp = this.currAbp.abp;
                }
            }
            const prgCount = [];
            const pprCount = [];
            const spfCount = [];
            if (this.curPrg.length !== this.prgBase.length) {
                this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
            }
            if (this.curPpr.length !== this.pprBase.length) {
                this.curPpr.forEach((row, ind) => { pprCount.push(row.ppr); });
            }
            if (this.curSpf.length !== this.spfBase.length) {
                this.curSpf.forEach((row, ind) => { spfCount.push(row.spf); });
            }
            const params = JSON.stringify({
                abp: cAbp,
                gu: cGu,
                type: that.version,
                level: that.accessLevels.position,
                region: that.currRegion.code,
                year: this.planPeriod.year,
                date: moment(that.date).format('YYYY-MM-DD'),
                ost: that.ost,
                vzk: that.vzk,
                project: that.project,
                fullRep: this.fullRep,
                locale: this.$i18n.locale,
                uid: this.userId,
                prgCount: prgCount,
                pprCount: pprCount,
                spfCount: spfCount,
                transf: that.transf
            });
            Ax(
                {
                    url: '/api-py/scorr-plan-expens-downloads/' +  encodeURI(params), //  Тело файла
                    method: 'POST',
                    responseType: 'blob'
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let name = ''
                    if (cAbp) {
                        name += `_${cAbp}`
                    }
                    if (cGu) {
                        name += `_${cGu.replace(/'/g, "")}`
                    }
                    name += `_${that.currRegion.code}_${moment(that.date).format('DD.MM.YYYY')}`

                    switch (this.$i18n.locale) {
                        case 'kk':
                            link.setAttribute('download', `Түзетілген жоспар(Шығыс)${name}.xls`);// or any other extension
                            break;
                        default:
                            link.setAttribute('download', `Скорректированный план(Расходы)${name}.xls`);// or any other extension
                    }
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    that.error = error;
                }
            );

        },
        downloadPlanAbp() {
            const curParams = {
                abp: this.currAbp.abp,
                abp261gu: this.abp261gu ? this.abp261gu.code : null,
                year: this.planPeriod.year,
                region: this.currRegion.code,
                type: this.version + 1,
                date: moment(this.date).format('YYYY-MM-DD'),
                project: this.project
            };
            try {
                this.makeToast('info', 'Внимание!', 'Скоро начнется скачивание. Пожалуйста ожидайте.');
                Ax(
                    {
                        url: '/api-py/scorr-plan-expens-download-abp/' + JSON.stringify(curParams),
                        method: 'POST',
                        responseType: 'blob'
                    },
                    (data) => {
                        const url = window.URL.createObjectURL(new Blob([data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Детальный план финансирования АБП.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    },
                    (error) => {
                        this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                    }
                );
            } catch (error) {
                console.log(error)
                this.makeToast('danger', 'Предупреждение', 'Необходимо заполнить все обязательные фильтры!');
            }
        },
        async loadAbpList() {
            const response = await fetch('/api-py/user-abp-list/' + this.userId);
            const newBase = await response.json();
            this.abpBase = this.setIdArr(newBase, "abp");
            if (['uf'].includes(this.accessLevels.position)) {
                this.abpBase.push({
                    "name_ru": "Все",
                    "name_kk": "Барлығы",
                    "name_en": "All",
                    "abp": 0,
                    "check": true
                });
            }
            this.nameLocale(this.abpBase, 'abp');
            this.abpBase.sort((a, b) => (a.abp - b.abp > 0 ? 1 : -1));
            this.currAbp = this.abpBase[0];
            await this.loadCompany();
            await this.loadRegions();
        },
        setIdArr(arr, codeName) {
            const result = [];
            for (const el of arr) {
                if (
                    result.length > 0 &&
                    el[codeName] === result[result.length - 1][codeName]
                ) {
                    result[result.length - 1].idArr.push(el.id);
                } else {
                    result.push(Object.assign({ idArr: [el.id] }, el));
                }
            }
            return result;
        },
        async loadCompany() {
            let result = [];
            if (this.currAbp !== null) {
                this.guBase = [];
                // Проверяем наличие прав доступа ABP напрямую через accessLevels
                const hasAbpAccess = this.accessLevels.operations && this.accessLevels.operations.some(op => op.toLowerCase().includes('abp'));

                if (hasAbpAccess && [261].includes(this.currAbp.abp)) {
                    // Для 261 АБП загружаем иерархию через loadDepartGU
                    await this.loadDepartGU();
                } else {
                    try {
                        result = await fetch(`/api/budget-execution-base/user/gu?abp=${this.currAbp.abp}`)
                            .then(response => response.json());
                    } catch (error) {
                        result = [];
                        this.makeToast('danger', this.setText('errors.gu'), error.toString());
                    }
                    this.abp261gu = null;
                }
                this.guBase = result;
                if (['abp', 'uf'].includes(this.accessLevels.position)) {
                    this.guBase.push({
                        "name_ru": "Все",
                        "name_kk": "Барлығы",
                        "name_en": "All",
                        "code": 0
                    });
                }
                this.nameLocale(this.guBase);
                this.guBase.sort((a, b) => (a.code - b.code > 0 ? 1 : -1));
                this.currGu = this.guBase[0];
            }
        },
        setNameLang(obj, codeName) {
            if (obj === null) { return null; }
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) { txt = obj.name_ru; }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                txt = obj[codeName] + ' - ' + txt;
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            el.localText = txt;
            return el;
        },
        async loadData() {
            const that = this;
            this.loading = true;
            let response = [];
            try {
                this.budgetForm = [];
                if (that.currRegion !== null) {
                    let cAbp = null;
                    let cGu = null;
                    if ((that.currGu === null) || (that.currGu === undefined)) {
                        cGu = null;
                    } else {
                        if (that.currGu.code === 0) {
                            cGu = null;
                            if (this.arrGU.length > 0) {
                                cGu = this.arrGU;
                            }
                        } else {
                            cGu = "'" + that.currGu.code.toString() + "'";
                        }
                    }
                    if ((that.currAbp === null) || (that.currAbp === undefined)) {
                        cAbp = null;
                    } else {
                        if (that.currAbp.abp === 0) {
                            cAbp = null;
                        } else {
                            cAbp = that.currAbp.abp;
                        }
                    }
                    const prgCount = [];
                    const pprCount = [];
                    const spfCount = [];
                    if (this.curPrg.length !== this.prgBase.length) {
                        this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
                    }
                    if (this.curPpr.length !== this.pprBase.length) {
                        this.curPpr.forEach((row, ind) => { pprCount.push(row.ppr); });
                    }
                    if (this.curSpf.length !== this.spfBase.length) {
                        this.curSpf.forEach((row, ind) => { spfCount.push(row.spf); });
                    }
                    const params = JSON.stringify({
                        abp: cAbp,
                        gu: cGu,
                        abp261gu: this.abp261gu ? this.abp261gu.code : null,
                        type: that.version,
                        level: that.accessLevels.position,
                        region: that.currRegion.code,
                        year: this.planPeriod.year,
                        date: moment(that.date).format('YYYY-MM-DD'),
                        ost: that.ost,
                        vzk: that.vzk,
                        project: that.project,
                        fullRep: this.fullRep,
                        locale: this.$i18n.locale,
                        uid: this.userId,
                        prgCount: prgCount,
                        pprCount: pprCount,
                        spfCount: spfCount
                    });
                    response = await fetch(`/api-py/scorr-plan-expens/` + encodeURI(params));
                    this.budgetForm = await response.json();
                }
                this.loading = false;
            } catch (error) {
                response = [];
                this.loading = false;
                this.makeToast(
                    "danger",
                    this.setText('errors.scorrPlanExp'),
                    this.setText('not_all_param')
                );
            }
            this.loading = false;
        },
        years(vue, arrYears) {
            const curYear = new Date().getFullYear();
            for (let i = curYear + 1; i >= 2023; i--) {
                const item = {year: i, name: `${i}`};
                arrYears.push(item);
                if (item.year === curYear) {
                    vue.planPeriod = item;
                }
            }
        },
        async loadDepartGU() {
            const that = this;
            try {
                let cAbp = null;
                if (that.currAbp && that.currAbp.abp !== 0) {
                    cAbp = that.currAbp.abp;
                }

                if (that.currRegion !== null) {
                    // ВАЖНО: Для загрузки списка подведомственных (departGU) мы НЕ передаем выбранный ГУ (gu: null).
                    // Список подведомственных должен зависеть только от АБП и Региона.
                    const paramsObj = {
                        abp: cAbp,
                        gu: null,
                        type: that.version,
                        level: that.accessLevels.position,
                        region: that.currRegion.code,
                        year: this.planPeriod.year,
                        date: moment(that.date).format('YYYY-MM-DD'),
                        ost: that.ost,
                        vzk: that.vzk,
                        project: that.project,
                        userId: this.userId
                    };

                    const response = await fetch('/api-py/get-abp-261-gu-scorr/' + encodeURI(JSON.stringify(paramsObj)));
                    const data = await response.json();

                    if (data && data.length > 0) {
                        data.push({
                            "name_ru": "Все",
                            "name_kk": "Барлығы",
                            "name_en": "All",
                            "code": 0,
                            "childGu": [],
                            "arrGu": [{ "name_ru": "Все", "name_kk": "Барлығы", "name_en": "All", "code": 0 }]
                        });
                        data.sort((a, b) => (a.code - b.code > 0 ? 1 : -1));

                        // Сохраняем текущий выбор подведомственного ГУ, если он еще доступен в новом списке
                        const prevCode = this.abp261gu ? this.abp261gu.code : null;
                        this.departGU = data;
                        this.nameLocale(this.departGU);

                        if (prevCode !== null) {
                            const found = this.departGU.find(item => item.code === prevCode);
                            this.abp261gu = found || this.departGU[0];
                        } else {
                            this.abp261gu = this.departGU[0];
                        }
                    } else {
                        this.departGU = [];
                        this.abp261gu = null;
                    }

                    // Исправляем инкремент: устанавливаем флаг доступа один раз
                    this.abp = this.accessLevels.operations.some(op => op.toLowerCase().includes('abp')) ? 1 : 0;
                }
            } catch (error) {
                this.makeToast('danger', this.setText('errors.ga'), error.toString());
            }
        },
        async guChange() {
            if (this.currGu && this.currGu.code) {
                this.currGu = this.setNameLang(this.findElByCode('code', this.currGu.code, this.guBase), 'code');
                await this.getRegionByCodeGu();

            } else {
                this.currGu = this.setNameLang(this.guBase[0], 'code');
            }
        },
        findElByCode(codeName, code, arr) {
            if (code === null) { return null; }
            for (const el of arr) {
                if (el[codeName] === code) {
                    return el;
                }
            }
            return null;
        },
        async getRegionByCodeGu() {
            this.regionBase = [];
            if (this.currGu && this.currGu.id_region) {
                    try {
                        const response = await fetch('/api-py/get-region-by-code-gu-sp', {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8'
                            },
                            body: JSON.stringify(this.currGu)
                        });
                        this.regionBase = await response.json();
                        this.nameLocale(this.regionBase);
                        if (this.regionBase && this.regionBase.length > 0) {
                            this.currRegion = this.regionBase[0];
                        }
                    } catch (error) {
                        this.makeToast('danger', this.setText('errors.region'), error.toString());
                    }
                }
        },
        sortData() {
            const abp = this.abp261gu;
            if (!abp) return;

            // 1. Упрощаем логику формирования arrGU
            this.arrGU = (abp.code !== 0 && abp.childGu)
                ? abp.childGu.join(',')
                : {}; // Оставляем {}, если так ожидает остальной код

            const guList = abp.arrGu;
            if (guList && guList.length > 0) {
                // 2. Сортировка и форматирование локального текста
                // Используем spread оператор [...], чтобы не мутировать исходный abp.arrGu
                const locale = this.$i18n.locale;

                this.guBase = [...guList]
                    .sort((a, b) => a.code - b.code)
                    .map(item => {
                        const name = item[`name_${locale}`] || item.name_ru;
                        return {
                            ...item,
                            localText: item.code === 0 ? `${name}` : `${item.code} - ${name}`
                        };
                    });

                // 3. Установка текущего ГУ
                this.currGu = this.guBase[0];
            } else {
                this.guBase = [];
                this.currGu = null;
            }
        },
        async loadFilters(){
            await this.loadRegions();
            await this.loadCompany();
            this.loadPrg();
        },
        sortByField(field) {
            return (a, b) => (a[field] > b[field] ? 1 : -1);
        }, // сортирует по заданному полю
        async loadFiltersData() {
            const that = this;
            try {
                let cAbp = null;
                let cGu = null;
                if ((that.currGu === null) || (that.currGu === undefined)) {
                    cGu = null;
                } else {
                    if (that.currGu.code === 0) {
                        cGu = null;
                        if (this.arrGU.length > 0) {
                            cGu = this.arrGU;
                        }
                    } else {
                        cGu = "'" + that.currGu.code.toString() + "'";
                    }
                }
                if ((that.currAbp === null) || (that.currAbp === undefined)) {
                    cAbp = null;
                } else {
                    if (that.currAbp.abp === 0) {
                        cAbp = null;
                    } else {
                        cAbp = that.currAbp.abp;
                    }
                }
                if (that.currRegion !== null) {
                    const params = JSON.stringify({
                        abp: cAbp,
                        gu: cGu,
                        type: that.version,
                        level: that.accessLevels.position,
                        region: that.currRegion.code,
                        year: this.planPeriod.year,
                        date: moment(that.date).format('YYYY-MM-DD'),
                        ost: that.ost,
                        vzk: that.vzk,
                        project: that.project,
                        fullRep: this.fullRep,
                        locale: this.$i18n.locale,
                        uid: this.userId
                    });
                    const response = await fetch('/api-py/have-abp-prg-prg-by-scorr-plan/' + encodeURI(params));
                    this.baseFilters = await response.json();
                    this.loadPrg();
                }
            } catch (error) {
                this.makeToast('danger', this.setText('errors.filter'), error.toString());
            }
        },
        newElem(field, code, text, value) {
            const el = {};
            this.$set(el, field, code);
            this.$set(el, 'localText', text);
            this.$set(el, 'check', false);
            return  Object.assign(el, value);
        }, // формирует элемент для отображения в фильтрах
        getRowKey(row, keys) {
            let key = '';
            for (const k of keys) {
                key = key + this.padLeadingZeros(row[k], 3) + '.';
            }
            return key;
        }, // преобразует значения выбранных полей в код
        // padLeadingZeros(num, size) {
        //     let s = String(num);
        //     while (s.length < size) { s = '0' + s; }
        //     return s;
        // }, // добавляет 0-ли перед num до size-значного размера
        loadPrg() {
            const that = this;
            const prgF = new Map();
            this.prgBase = [];
            let prgCurr = [];
            if (this.currAbp !== null && this.currAbp.abp > 0) {
                prgCurr = this.baseFilters.filter((item) => item.abp === this.currAbp.abp)
            } else {
                prgCurr = this.baseFilters;
            }
            for (const row of prgCurr) {
                prgF.set(that.getRowKey(row, ['prg']),
                    that.newElem('prg', row['prg'], this.padLeadingZeros(row['prg'], 3) + ' - ' + this.setText('program'), row));
            }
            prgF.forEach((row, ind) => {
                this.prgBase.push(that.newElem('prg', row['prg'], row['localText'], row));
            });
            this.prgBase.sort((a, b) => (a.prg - b.prg > 0 ? 1 : -1))
            this.curPrg = this.prgBase.slice();
            this.loadPpr();
        },
        loadPpr() {
            const that = this;
            const pprF = new Map();
            this.pprBase = [];
            let pprCurr = [];
            if (['uf'].includes(this.accessLevels.position)) {
            }
            const prgCount = [];
            if (this.curPrg !== undefined && this.curPrg !== null && Object.keys(this.curPrg).length > 0) {
                this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
                if (this.currAbp.abp !== 0) {
                    pprCurr = this.baseFilters.filter((item) => prgCount.includes(item.prg) && (item.abp === this.currAbp.abp));
                } else {
                    pprCurr = this.baseFilters.filter((item) => prgCount.includes(item.prg));
                }
            } else {
                pprCurr = this.baseFilters;
            }
            for (const row of pprCurr) {
                pprF.set(that.getRowKey(row, ['ppr']),
                    that.newElem('ppr', row['ppr'], this.padLeadingZeros(row['ppr'], 3) + ' - ' + this.setText('ppr'), row));
            }
            pprF.forEach((row, ind) => {
                this.pprBase.push(that.newElem('ppr', row['ppr'], row['localText'], row));
            });
            this.pprBase.sort((a, b) => (a.ppr - b.ppr > 0 ? 1 : -1))
            this.curPpr = this.pprBase.slice();
            this.loadSpf();
        },
        loadSpf() {
            const that = this;
            const spfF = new Map();
            this.spfBase = [];
            let spfCurr = [];
            const prgCount = [];
            const pprCount = [];
            this.curPrg.forEach((row, ind) => { prgCount.push(row.prg); });
            this.curPpr.forEach((row, ind) => { pprCount.push(row.ppr); });
            if (this.currAbp.abp !== 0) {
                spfCurr = this.baseFilters.filter((item) => prgCount.includes(item.prg) && pprCount.includes(item.ppr) && (item.abp === this.currAbp.abp))
            } else {
                spfCurr = this.baseFilters.filter((item) => prgCount.includes(item.prg) && pprCount.includes(item.ppr))
            }
            for (const row of spfCurr) {
                spfF.set(that.getRowKey(row, ['spf']),
                    that.newElem('spf', row['spf'], this.padLeadingZeros(row['spf'], 3) + ' - ' + row['spf_name_' + this.locale], row));
            }
            spfF.forEach((row, ind) => {
                this.spfBase.push(that.newElem('spf', row['spf'], row['localText'], row));
            });
            this.spfBase.sort((a, b) => (a.spf - b.spf > 0 ? 1 : -1))
            this.curSpf = this.spfBase.slice();
        },
        chgPrg() {
            this.loadPpr();
        },
        chgPpr() {
            this.loadSpf();
        },
        selectAllPrgChanged() {
            if (this.isAllPrgSelected) {
                this.curPrg = []
            } else { this.curPrg = this.prgBase.slice() }
        },
        selectAllPprChanged() {
            if (this.isAllPprSelected) {
                this.curPpr = []
            } else { this.curPpr = this.pprBase.slice() }
        },
        selectAllSpfChanged() {
            if (this.isAllSpfSelected) {
                this.curSpf = []
            } else { this.curSpf = this.spfBase.slice() }
        },
        displayPrgText(count){
            if (count === this.prgBase.length){
                return this.setText('all')
            }
            else if (count ===1){
                return this.value[0].name
            }
            else { return  count + this.setText('prg_sel')}
        },
        displayPprText(count){
            if (count === this.pprBase.length){
                return this.setText('all')
            }
            else if (count ===1){
                return this.value[0].name
            }
            else { return  count + this.setText('ppr_sel')}
        },
        displaySpfText(count){
            if (count === this.spfBase.length){
                return this.setText('all')
            }
            else if (count ===1){
                return this.value[0].name
            }
            else { return  count + this.setText('spf_sel')}
        },
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
}
</script>


<style lang="scss" scoped>
.content {
    display: flex;
    gap: 20px;
    background-color: #eef1f8;
    justify-content: space-between;
}

.content {
    height: 100%;
    .title {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        padding-left: 20px;
        margin-bottom: 26px;
    }
    .constructor,
    .forms {
        flex: 1;
    }

    .body {
        background-color: #f7f9fc;
    }

    .item {
        display: flex;
        align-items: center;
        height: 48px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .multiselect {
        max-width: 400px;
    }

    .footer {
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: end;
        border: 1px solid #d3dbe3;
        border-top: 0;
        padding-right: 40.5%;
    }

    .vertical-line {
        width: 1px;
        background-color: #d3dbe3;
        margin-top: 40px;
    }
}
.add_modal {
    width:100%;
    height:100%;
    &__body {
        background-color: #f7f9fc;
        border: 1px solid #d3dbe3;
        border-radius: 5px;
        margin-bottom: 23px;
    }

    &__title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 26px;
    }

    &__item {
        display: flex;
        align-items: center;
        height: 50px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0px 10px 0px 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .input-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
        &-label {
            width: 400px;
            font-weight: 600;
            font-size: 14px;
            color: #6087a0;
            cursor: pointer;
            display: flex;
            justify-self: flex-start;
        }
    }
    .form-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
    }
}
.button {
    border: none;
    border-radius: 10px;
}

.button-close {
    color: red;
}
.second-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 26px;
    &__title {
        font-weight: 500;
        font-size: 14px;
    }
}

.date-picker-container {
    display: flex;
    gap: 79px;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #6087a0;

    input[type="number"] {
        border: 1px solid #bcd2e0;
        border-radius: 5px;
        padding-right: 5px;
        max-width: 80px;
        height: 28px;
        text-indent: 7px;
        text-align: left;
    }
}

</style>